<template>
  <div class="price-extra-info-container">
    <template v-if="mode === 'desktop'">
      <AffirmMessaging v-if="showAffirm" :is-pdp="true" :price="price.final" />
      <PaybrightMessaging v-if="showPaybright" :price-in-cents="price.final" />
      <div v-if="showDivider" class="mini-divider"></div>
    </template>

    <div class="extra-info" :data-amount="price.final" :class="[{ 'hide-top-info': hideTopInfo }, mode]">
      <a v-if="mode === 'aside'" href="/value">
        <span class="af-about-small af"></span><span>Retail {{ price.retailFormatted }} - You save {{ price.retailSavingFormatted }}</span>
      </a>
      <a v-else href="/value"
        ><span>Retail {{ price.retailFormatted }} - You save {{ price.retailSavingFormatted }}</span> <span class="extra-info-text af-about-small"></span
      ></a>

      <template v-if="mode === 'top' || mode === 'pla' || mode === 'aside'">
        <AffirmMessaging v-if="showAffirm" :is-pdp="true" :price="price.final" />
        <PaybrightMessaging v-if="showPaybright" :price-in-cents="price.final" />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Financing from '@/components/commons/Financing.js';

export default {
  name: 'PriceExtraInfo',
  components: {
    AffirmMessaging: () => import(/* webpackChunkName: "AffirmMessaging" */ '@/components/commons/AffirmMessaging.vue'),
    PaybrightMessaging: () => import(/* webpackChunkName: "PaybrightMessaging" */ '@/components/commons/PaybrightMessaging.vue')
  },
  props: {
    hideTopInfo: {
      default: false,
    },
    mode: {
      validator(value) {
        return ['top', 'desktop', 'mobile', 'aside'].includes(value);
      },
    },
  },
  computed: {
    ...mapState('common', [
      'financing'
    ]),
    ...mapState('product', [
      'product'
    ]),
    ...mapGetters('product', [
      'price'
    ]),
    showAffirm() {
      return Financing.isAffirmEnabled(this.amount, this.financing);
    },
    showPaybright() {
      return Financing.isPaybrightEnabled(this.amount, this.financing);
    },
    showDivider() {
      return this.showAffirm || this.showPaybright;
    },
    amount() {
      return this.price && this.price.final ? this.price.final / 100 : 0;
    },
  }
};
</script>

<style lang="scss" scoped>
@import '~@article/pixel/dist/style/variables';

.price-extra-info-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: var(--font-size-12);

  .mini-divider {
    height: var(--space-2);
    margin: var(--space-2);
    margin-bottom: var(--space-0);
    padding: 0px;
    border-left: 1px solid var(--grey-light);
  }

  .affirm-message {
    .affirm-modal-trigger {
      white-space: nowrap;
    }
  }

  .affirm-message, .paybright-message {
    color: var(--grey-medium);
    margin-top: var(--space-2);
  }

  .extra-info {
    text-align: center;

    .extra-info-text {
      color: var(--grey-medium);
      letter-spacing: 0;
      margin-top: var(--space-4);

      &:hover {
        color: var(--grey-light);
      }
    }

    & > * {
      font-size: var(--font-size-12);
      letter-spacing: 1px;
      color: var(--grey-medium);
    }

    .affirm-message,
    .paybright-message {
      margin-top: -4px;
    }

    &.top {
      text-align: right;
      margin-top: -16px;
      margin-bottom: 8px;
      margin-right: 20px;

      transition: transform ease-in 450ms, opacity ease-in 450ms;

      &.hide-top-info {
        pointer-events: none;
        transform: translateY(-20px);
        opacity: 0;
        transition-timing-function: ease-out;
      }
    }

    &.desktop {
      clear: both;
      text-align: right;
      margin-top: var(--space-2);
      margin-right: var(--space-4);
      line-height: var(--line-height-12);
    }

    &.aside {
      font-size: var(--font-size-14);
      text-align: left;
      margin-top: 6px;

      & > * {
        font-size: 1em;
        letter-spacing: unset;
      }

      .extra-info-text {
        font-size: 14px;
        color: $base-font-color;
      }

      a {
        .af {
          font-size: 16px;
          color: $coral;
          margin-right: 12px;
        }
      }

      .affirm-message {
        padding-left: 28px;
        padding-top: 8px;
      }

      .paybright-message {
        margin-top: var(--space-1);
      }
    }
  }
}
</style>
